export const PHONE_REGEX = /^1[3-9]\d{9}$/

export function getStudentFormError(form) {
  if (!form.studentName.trim()) return '请输入学员姓名'
  if (!form.sex) return '请选择性别'
  if (!form.status) return '请选择状态'
  if (!form.grade) return '请选择年级'
  if (!form.schoolId) return '请选择所属校区'
  if (!form.plannerId) return '请选择规划师'
  if (!PHONE_REGEX.test(form.phone)) return '请输入正确的手机号'
  if (!form.birthday) return '请选择出生日期'
  if (!form.source) return '请选择学生来源'
  return ''
}

export function buildStudentPayload(form) {
  return {
    studentName: form.studentName,
    sex: Number(form.sex),
    status: Number(form.status),
    grade: Number(form.grade),
    schoolId: form.schoolId,
    plannerId: form.plannerId,
    phone: form.phone,
    birthday: form.birthday,
    source: Number(form.source),
    isSendNotice: 0
  }
}

export function getConsultationFormError(form) {
  if (!form.contactName.trim()) return '请输入联系人名称'
  if (!form.phone && !form.otherContact) return '请输入手机号或其他联系方式'
  if (form.phone && !PHONE_REGEX.test(form.phone)) return '请输入正确的手机号'
  if (!form.source) return '请选择来源'
  if (!form.nearbySchoolId) return '请选择就近校区'
  return ''
}

export function buildConsultationPayload(form) {
  return {
    contactName: form.contactName,
    phone: form.phone || undefined,
    otherConcatMethods: form.otherContact || undefined,
    source: Number(form.source),
    nearbySchoolId: form.nearbySchoolId,
    area: form.area ? Number(form.area) : undefined,
    grade: form.grade ? Number(form.grade) : undefined,
    followUserId: form.followUserId || undefined,
    studentType: form.studentType ? Number(form.studentType) : undefined,
    clueQuality: form.quality ? Number(form.quality) : undefined,
    type: form.type ? Number(form.type) : undefined,
    intentionSubjectArr: form.subjects,
    intentionSubject: form.subjects.join(','),
    remark: form.remark || undefined
  }
}
